/**
 * Layout Component - Main layout wrapper with breadcrumbs below header
 */

import React from 'react'
import Sidebar from './Sidebar'
import Header from './Header'
import MobileNav from './MobileNav'
import Breadcrumbs from './Breadcrumbs'

const Layout = ({
  children,
  nav = [],
  activeTab,
  onNavigate,
  onMenu,
  mobileOpen,
  onCloseMobile,
  company,
  user,
  profile,
  role,
  onLogout,
  onProfileClick,
  headerProps = {},
  breadcrumbs = [],
  className = '',
  ...props
}) => {
  return (
    <div className={`flex h-full ${className}`} {...props}>
      {/* Sidebar - Desktop */}
      <Sidebar
        nav={nav}
        activeTab={activeTab}
        onSelect={onNavigate}
        mobileOpen={mobileOpen}
        onCloseMobile={onCloseMobile}
        onLogout={onLogout}  // ✅ Pass logout to sidebar
      />

      {/* Main Content */}
      <div className="flex-1 flex flex-col min-w-0">
        {/* Header - still has profile dropdown with logout */}
        <Header
          company={company}
          user={user}
          profile={profile}
          role={role}
          onMenu={onMenu}
          onLogout={onLogout}
          onProfileClick={onProfileClick}
          onNavigate={onNavigate}
          {...headerProps}
        />

        {/* Breadcrumbs */}
        {breadcrumbs && breadcrumbs.length > 0 && (
          <div className="px-4 sm:px-6 py-2 border-b border-neutral-100 bg-neutral-50/50">
            <Breadcrumbs
              items={breadcrumbs}
              onNavigate={onNavigate}
            />
          </div>
        )}

        {/* Page Content */}
        <main className="flex-1 overflow-y-auto bg-background pb-16 md:pb-0">
          {children}
        </main>

        {/* Mobile Navigation */}
        <MobileNav
          items={nav}
          activeTab={activeTab}
          onSelect={onNavigate}
        />
      </div>
    </div>
  )
}

Layout.displayName = 'Layout'

export default Layout